module.exports = __webpack_public_path__ + "static/media/homepage-overlay-1.f689dd7e.jpg";